import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'
import WhyChooseUs from '../components/WhyChooseUs'
import InfiniteReferencesSlider from '../components/InfiniteReferencesSlider'
import GallerySection from '../components/GallerySection'

export default function HomePage() {
  const birgitteImage =
    'https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=85,format=auto/assets/f84d998e-98b3-4e41-8b24-7500b03ebc9a/birgitte-billede.jpg'

  return (
    <>
      <SEO isHome={true} />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-b from-sky-50/60 via-white to-white pt-12 sm:pt-16 lg:pt-24 pb-12 sm:pb-16 lg:pb-24 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
            {/* Hero Left Content */}
            <div className="lg:col-span-7 space-y-7">
              <h1 className="text-4xl sm:text-6xl lg:text-7xl font-black text-black tracking-tight leading-[1.08]">
                IT & Tech Recruitment
              </h1>

              <p className="text-lg sm:text-xl text-black leading-relaxed font-normal max-w-2xl">
                Med mange års erfaring med IT & Tech Recruitment og Talent Acqusition hjælper jeg virksomheder med at finde og tiltrække de skarpeste IT-specialister.
              </p>

              {/* CTAs */}
              <div className="pt-2 flex flex-wrap items-center gap-4">
                <Link
                  to="/kontakt"
                  className="px-7 py-4 bg-slate-900 hover:bg-black text-white font-bold transition-all cursor-pointer flex items-center gap-2.5 text-base"
                >
                  <i className="fa-solid fa-calendar-check" aria-hidden="true" />
                  <span>Book en samtale</span>
                </Link>

                <Link
                  to="/erfaring"
                  className="px-7 py-4 bg-white hover:bg-slate-100 text-black font-bold border border-slate-300 transition-all cursor-pointer flex items-center gap-2.5 text-base"
                >
                  <i className="fa-solid fa-briefcase text-black" aria-hidden="true" />
                  <span>Se erfaring</span>
                </Link>

                <Link
                  to="/kontakt"
                  className="px-6 py-4 text-black hover:opacity-75 font-bold transition-colors cursor-pointer text-base"
                >
                  Kontakt Birgitte →
                </Link>
              </div>

              {/* Quick Info Badges */}
              <div className="pt-7 border-t border-slate-200 flex flex-wrap items-center gap-6 sm:gap-8 text-sm text-black font-medium">
                <div className="flex items-center gap-2">
                  <i className="fa-solid fa-circle-check text-black" aria-hidden="true" />
                  <span>100% Personlig headhunting</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="fa-solid fa-circle-check text-black" aria-hidden="true" />
                  <span>Specialiseret kandidatdatabase</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="fa-solid fa-circle-check text-black" aria-hidden="true" />
                  <span>Svendborg & Hele Danmark</span>
                </div>
              </div>
            </div>

            {/* Hero Right Image - Birgitte Vilsgaard */}
            <div className="lg:col-span-5 relative">
              <div className="relative mx-auto max-w-md lg:max-w-none">
                <div className="absolute -inset-4 bg-gradient-to-tr from-sky-400 to-teal-400 opacity-20 blur-xl" />
                <div className="relative overflow-hidden border-4 border-white bg-white">
                  <img
                    src={birgitteImage}
                    alt="Birgitte Vilsgaard - IT & Tech Recruitment Specialist"
                    className="w-full h-[450px] sm:h-[520px] lg:h-[560px] object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Om Birgitte Teaser */}
      <section className="py-10 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-5 order-2 lg:order-1">
              <div className="overflow-hidden border border-slate-200">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/f84d998e-98b3-4e41-8b24-7500b03ebc9a/headhunting-interview-meeting.jpg"
                  alt="Birgitte Vilsgaard rådgivning og kandidatsamtale"
                  className="w-full h-[400px] object-cover"
                />
              </div>
            </div>

            <div className="lg:col-span-7 order-1 lg:order-2 space-y-5">
              <h2 className="text-3xl sm:text-4xl font-extrabold text-black tracking-tight">
                Rekruttering bygget på tillid og dyb tech-forståelse
              </h2>
              <p className="text-black text-base leading-relaxed">
                Som den primære profil og virksomhedens ansigt udadtil driver jeg Insightly Care med en ambition om at gøre IT-rekruttering mere nærværende og mere præcis. For mig handler rekruttering ikke blot om at matche et CV med en jobbeskrivelse, men om at forstå kulturen, teknologien og ambitionerne i virksomheden.
              </p>
              <div className="pt-2">
                <Link
                  to="/om-birgitte"
                  className="inline-flex items-center gap-2 px-5 py-3 bg-slate-900 hover:bg-black text-white font-bold text-sm transition-colors"
                >
                  <span>Læs mere om Birgitte Vilsgaard</span>
                  <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Component */}
      <WhyChooseUs />

      {/* Services Overview Teaser */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            {/* Left Column: Heading + Service Items */}
            <div className="lg:col-span-7 space-y-8">
              <div>
                <h2 className="text-3xl sm:text-4xl font-extrabold text-black tracking-tight mt-1">
                  IT &amp; Tech Recruitment
                </h2>
                <p className="text-black mt-3 text-base leading-relaxed">
                  Skræddersyede løsninger inden for search, headhunting og rådgivning til digitale organisationer.
                </p>
              </div>

              <div className="space-y-6">
                <div className="flex gap-4 p-5 rounded-xl bg-slate-50 border border-slate-200/80 hover:border-slate-300 transition-all">
                  <div className="w-12 h-12 shrink-0 bg-slate-900 text-white flex items-center justify-center text-xl rounded-lg">
                    <i className="fa-solid fa-magnifying-glass-chart" aria-hidden="true" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-black mb-1">Search &amp; Headhunting</h3>
                    <p className="text-black text-sm leading-relaxed mb-3">
                      Opsøgende rekruttering af passive tech-kandidater i et konkurrencepræget marked.
                    </p>
                    <Link to="/kontakt" className="text-sm font-bold text-black hover:opacity-75 inline-flex items-center gap-1.5">
                      <span>Kontakt for rådgivning</span>
                      <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
                    </Link>
                  </div>
                </div>

                <div className="flex gap-4 p-5 rounded-xl bg-slate-50 border border-slate-200/80 hover:border-slate-300 transition-all">
                  <div className="w-12 h-12 shrink-0 bg-slate-900 text-white flex items-center justify-center text-xl rounded-lg">
                    <i className="fa-solid fa-clipboard-check" aria-hidden="true" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-black mb-1">Kandidatvurdering</h3>
                    <p className="text-black text-sm leading-relaxed mb-3">
                      Grundig faglige screening samt certificerede personlighedsprofiler og kompetencetest.
                    </p>
                    <Link to="/kontakt" className="text-sm font-bold text-black hover:opacity-75 inline-flex items-center gap-1.5">
                      <span>Kontakt for rådgivning</span>
                      <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
                    </Link>
                  </div>
                </div>

                <div className="flex gap-4 p-5 rounded-xl bg-slate-50 border border-slate-200/80 hover:border-slate-300 transition-all">
                  <div className="w-12 h-12 shrink-0 bg-slate-900 text-white flex items-center justify-center text-xl rounded-lg">
                    <i className="fa-solid fa-comments text-xl" aria-hidden="true" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-black mb-1">C-level &amp; HR Sparring</h3>
                    <p className="text-black text-sm leading-relaxed mb-3">
                      Rådgivning om talentattraktion, lønniveauer i IT-sektoren og fastholdelsesstrategier.
                    </p>
                    <Link to="/kontakt" className="text-sm font-bold text-black hover:opacity-75 inline-flex items-center gap-1.5">
                      <span>Kontakt for rådgivning</span>
                      <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column: Image */}
            <div className="lg:col-span-5 relative">
              <div className="relative mx-auto max-w-md lg:max-w-none">
                <div className="overflow-hidden border-4 border-white bg-white rounded-2xl">
                  <img
                    src="https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=85,format=auto/assets/f84d998e-98b3-4e41-8b24-7500b03ebc9a/danish-tech-office-team.jpg"
                    alt="IT &amp; Tech Recruitment team og konsulenter i dialog"
                    className="w-full h-[540px] object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* References Infinite Slider Section */}
      <section className="py-20 bg-slate-50 border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-10 text-center">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-black tracking-tight">
              Hvad siger vores kunder og kandidater?
            </h2>
            <p className="text-black mt-2 text-sm">
              Udtalelser og anbefalinger direkte fra samarbejdspartnere og IT-specialister.
            </p>
          </div>

          <InfiniteReferencesSlider />

          <div className="text-center mt-10">
            <Link
              to="/referencer"
              className="inline-flex items-center gap-2 text-sm font-bold text-black hover:opacity-75 underline"
            >
              <span>Se alle referencer og anbefalinger</span>
              <i className="fa-solid fa-arrow-right text-xs text-black" aria-hidden="true" />
            </Link>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <GallerySection gallerySlug="rekruttering-og-kontor" />

      {/* Call to Action Banner */}
      <section className="relative py-20 bg-slate-900 text-white overflow-hidden">
        <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-6">
          <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-white">
            Klar til at styrke dit IT-hold med de rette talenter?
          </h2>
          <p className="text-slate-300 max-w-2xl mx-auto text-base leading-relaxed">
            Kontakt Birgitte Vilsgaard i dag for en uforpligtende samtale om jeres rekrutteringsbehov i IT- & Tech-sektoren.
          </p>
          <div className="pt-4 flex flex-wrap justify-center items-center gap-4">
            <Link
              to="/kontakt"
              className="px-8 py-4 bg-white text-black hover:bg-slate-100 font-extrabold transition-all cursor-pointer"
            >
              Book en samtale nu
            </Link>
            <a
              href="tel:28839488"
              className="px-8 py-4 bg-slate-800 hover:bg-slate-700 text-white font-bold border border-slate-700 transition-colors whitespace-nowrap"
            >
              <i className="fa-solid fa-phone mr-2" aria-hidden="true" />
              <span className="whitespace-nowrap">Ring på 28 83 94 88</span>
            </a>
          </div>
        </div>
      </section>
    </>
  )
}
